"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagesList = exports.languageMap = void 0;
/**
 * Language map from language code to language interface
 */
exports.languageMap = {
    AS: {
        name: 'Assamese',
        primary_name: 'অসমীয়া',
        basic_support: false,
        assistant_support: false,
    },
    BN: {
        name: 'Bengali',
        primary_name: 'বাংলা',
        basic_support: false,
        assistant_support: false,
    },
    BRX: {
        name: 'Bodo',
        primary_name: 'बड़',
        basic_support: false,
        assistant_support: false,
    },
    DOI: {
        name: 'Dogri',
        primary_name: 'डोगरी',
        basic_support: false,
        assistant_support: false,
    },
    EN: {
        name: 'English',
        primary_name: 'English',
        basic_support: true,
        assistant_support: false,
    },
    GU: {
        name: 'Gujarati',
        primary_name: 'ગુજરાતી',
        basic_support: false,
        assistant_support: false,
    },
    HI: {
        name: 'Hindi',
        primary_name: 'हिंदी',
        basic_support: false,
        assistant_support: false,
    },
    KOK: {
        name: 'Konkani',
        primary_name: 'कोंकणी',
        basic_support: false,
        assistant_support: false,
    },
    KN: {
        name: 'Kannada',
        primary_name: 'ಕನ್ನಡ',
        basic_support: false,
        assistant_support: false,
    },
    KS: {
        name: 'Kashmiri',
        primary_name: 'कॉशुर',
        basic_support: false,
        assistant_support: false,
    },
    MAI: {
        name: 'Maithili',
        primary_name: 'मैथिली',
        basic_support: false,
        assistant_support: false,
    },
    ML: {
        name: 'Malayalam',
        primary_name: 'മലയാളം',
        basic_support: false,
        assistant_support: false,
    },
    MNI: {
        name: 'Manipuri',
        primary_name: 'ꯃꯤꯇꯩꯂꯣꯟ',
        basic_support: false,
        assistant_support: false,
    },
    MR: {
        name: 'Marathi',
        primary_name: 'मराठी',
        basic_support: false,
        assistant_support: false,
    },
    NE: {
        name: 'Nepali',
        primary_name: 'नेपाली',
        basic_support: false,
        assistant_support: false,
    },
    PA: {
        name: 'Punjabi',
        primary_name: 'ਪੰਜਾਬੀ',
        basic_support: false,
        assistant_support: false,
    },
    OR: {
        name: 'Odia',
        primary_name: 'ଓଡ଼ିଆ',
        basic_support: false,
        assistant_support: false,
    },
    SA: {
        name: 'Sanskrit',
        primary_name: 'संस्कृत',
        basic_support: false,
        assistant_support: false,
    },
    SAT: {
        name: 'Santali',
        primary_name: 'संताली',
        basic_support: false,
        assistant_support: false,
    },
    SD: {
        name: 'Sindhi',
        primary_name: 'सिन्धी',
        basic_support: false,
        assistant_support: false,
    },
    TE: {
        name: 'Telugu',
        primary_name: 'తెలుగు',
        basic_support: false,
        assistant_support: false,
    },
    TA: {
        name: 'Tamil',
        primary_name: 'தமிழ்',
        basic_support: false,
        assistant_support: false,
    },
    UR: {
        name: 'Urdu',
        primary_name: 'اُردُو',
        basic_support: false,
        assistant_support: false,
    },
    ISL: {
        name: 'Sign Language',
        primary_name: 'Sign Language',
        basic_support: false,
        assistant_support: false,
    },
    NRI: {
        name: 'Chokri',
        primary_name: 'Chokri',
        basic_support: false,
        assistant_support: false,
    },
};
exports.languagesList = Object.fromEntries(Object.entries(exports.languageMap).map(([code, info]) => [code, info.name]));
//# sourceMappingURL=Index.js.map